import { InputBox, Dropdown } from "@components/index";
import { REJCTION_REASONS, useClaimActionData } from "./claimActionData";
import "./index.scss";

const ClaimAction = (props) => {
  const { claimData, claimAction, handleCancelAction, loadClaimsData } = props;

  const {
    selectedRejectionReason,
    handleRejectionReasonChange,
    remarks,
    handleRemarksChange,
    claimDecisionSubmitHandler,
    claimActionLoading,
  } = useClaimActionData({ handleCancelAction, loadClaimsData });

  return (
    <div className="claim-action">
      <h2 className="claim-action_header">{claimData?.claim_id}</h2>

      <div className="claim-action_body">
        {claimAction === "approve" && (
          <div className="claim-action_body-approval">
            <p className="claim-action_body-approval-title">
              Please Confirm below to continue
            </p>
          </div>
        )}

        {claimAction === "reject" && (
          <>
            <div className="claim-action_body-rejection-reason">
              <p className="claim-action_body-rejection-reason-title">
                Please select the rejection reason*
              </p>

              <Dropdown
                label="Select Rejection Reason"
                value={selectedRejectionReason}
                onChange={handleRejectionReasonChange}
                options={REJCTION_REASONS}
                className="claim-action_body-rejection-reason-dropdown"
              />
            </div>

            <div className="claim-action_body-remarks">
              <p className="claim-action_body-remarks-title">
                Remarks (Optional)
              </p>

              <InputBox
                value={remarks}
                onChange={handleRemarksChange}
                className="claim-action_body-remarks-input"
              />
            </div>
          </>
        )}
      </div>

      <div className="claim-action_footer">
        <button
          className={`claim-action_footer-button claim-action_footer-button-${
            claimAction === "approve"
              ? "approve"
              : selectedRejectionReason
                ? "reject"
                : "reject-disabled"
          } `}
          onClick={() => claimDecisionSubmitHandler(claimData, claimAction)}
          isloading={claimActionLoading ? "true" : undefined}
        >
          {claimAction === "approve" ? "Approve" : "Reject"}
        </button>

        <button
          className="claim-action_footer-button claim-action_footer-button-cancel"
          onClick={handleCancelAction}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ClaimAction;
